export const SLICE_NAME = "componentsListing";